import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Collapse from "@material-ui/core/Collapse";
import useToggle from "../../../hooks/useToggle";
import ExpandMore from "./ExpandMore.tsx";

interface IExpadirProps {
    children: React.ReactNode;
    bonusIcon?: IconProp;
    hideHR?: boolean;

    mountOnEnter?: boolean;
    unmountOnExit?: boolean;
    justify?: "center" | "start" | "end";

    position?: "top" | "bottom";
}

export default function Expadir(props: IExpadirProps) {
    const [expandido, toggleExpandido] = useToggle();

    const collapseComponent = (
        <Collapse
            in={expandido}
            timeout="auto"
            unmountOnExit={props.unmountOnExit}
            mountOnEnter={props.mountOnEnter}
        >
            {props.children}
        </Collapse>
    );

    return (
        <div>
            {!props.hideHR && <hr className="mb-3 mt-10" />}
            {props.position === "top" && collapseComponent}
            <ExpandMore
                expand={expandido}
                onClick={toggleExpandido}
                aria-expanded={expandido}
                aria-label="mostre mais"
                className="mb-2"
                siblingNode={
                    props.bonusIcon && (
                        <FontAwesomeIcon
                            icon={props.bonusIcon}
                            className="mx-2"
                        />
                    )
                }
                justify={props.justify}
            >
                <FontAwesomeIcon icon={faChevronDown} />
            </ExpandMore>
            {props.position !== "top" && collapseComponent}
        </div>
    );
}
